// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__1HQ34","tab":"TabNav_tab__2ArpE","link":"TabNav_link__1EYTx","selectedLink":"TabNav_selectedLink__3QsLY","disabled":"TabNav_disabled__21n-2"};